export default __webpack_public_path__ + "static/media/testimonials-slider-thumbnail.299d7976.png";